/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Flex, Image, useBreakpointValue } from '@chakra-ui/react';
import { TbPlayerPlayFilled } from 'react-icons/tb';
import { useMediaQuery } from 'react-responsive';
import YouTube from 'react-youtube';
import { FaRegCirclePlay } from 'react-icons/fa6';
// import ReactPlayer from 'react-player';

/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import { getEmbedUrl } from '@components/Utility/utils';

/* Services */
import { isInViewport } from '@components/Utility/Shared/SharedService';

/* Styles */
import ProgramStepsSt from '@ieo/Common/StyleData/ProgramStepsSt';
import { usePathname } from 'next/navigation';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for Section
 * @param sectionContent.margin
 * @param sectionContent.width
 * @param sectionContent.pxBase
 * @returns {ReactElement} MediaEmbed component
 */

const MediaEmbedV2 = ({
  sectionContent,
  margin,
  width,
  height,
  lang,
  pageName,
  isUsInPerson,
  useOutlinePlayIcon = false,
  ...props
}) => {
  const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});
  const path = usePathname();
  const checkV5Version = path.includes('v5');
  // const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [screenWidth, setScreenWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const imgSrc = useBreakpointValue({
    base: sectionContent?.thumbnailMobileImage?.url,
    md: sectionContent?.thumbnailDesktopImage?.url,
  });

  useEffect(() => {
    setOpts({
      height: isMobile ? '200px' : pageName == 'pbk' ? '413px' : '420px',
      //height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window, isMobile]);

  useEffect(() => {
    if (props.autoplay) {
      window.addEventListener('scroll', listenToScroll);
    }
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const scrollDiv = document.getElementById(props['sectionId']);
    const inViewPort = isInViewport(scrollDiv);
    if (!vidVis && inViewPort) {
      setVidVis(true);
    }

    // console.log('sdsdsd', props['sectionId'], inViewPort);
    // const heightToHideFrom = window.innerHeight / 1.5;
    // const winScroll = document.body.scrollTop ||
    //   document.documentElement.scrollTop;

    // if (winScroll > heightToHideFrom) {
    //   setVidVis(true);
    // }
  };

  const onReady = event => {
    event.target.playVideo();
  };

  const playerOverlay =
    props?.sectionId === 'ieo-program-steps' ? (
      <Box
        pos="relative"
        // bg="black"
        w="full"
        h="full"
        display={vidVis ? 'none' : 'block'}
        onClick={e => setVidVis(!vidVis)}
      >
        <Flex
          flexDir="column"
          gridGap={{
            base: checkV5Version ? '2px' : '6px',
            md: checkV5Version ? '4px' : '11px',
          }}
          pos="absolute"
          left={{ base: '1rem', md: '1.2rem' }}
          bottom={{
            base: checkV5Version ? '24px' : '65px',
            sm: checkV5Version && '14px',
            md: 'unset',
          }}
          top={{
            base: '33%',
            md: '36%',
            lg: checkV5Version ? '43%' : '35%',
          }}
        >
          <Flex
            align="center"
            justify="center"
            w={{ base: '39px', md: '73px' }}
            h={{ base: '39px', md: '73px' }}
            bg={checkV5Version ? 'transparent' : 'white'}
            borderRadius={checkV5Version !== true && (props.round || '50%')}
            onClick={e => setVidVis(!vidVis)}
            display={vidVis ? 'none' : 'flex'}
          >
            <Flex
              align="center"
              justify="center"
              w={{
                base: checkV5Version ? '39.8px' : '35px',
                md: checkV5Version ? '77.36px' : '65px',
              }}
              h={{
                base: checkV5Version ? '39.8px' : '35px',
                md: checkV5Version ? '76.88px' : '65px',
              }}
              fontSize={{ base: '26px', md: '45px' }}
              borderRadius="50%"
              bg={checkV5Version ? 'transparent' : '#9A4C21'}
              color="white"
            >
              {' '}
              {checkV5Version ? (
                <Image
                  src={
                    pageName == 'uyirnokkam'
                      ? 'https://www.datocms-assets.com/46272/1736418243-play_btn_icon.png'
                      : 'https://www.datocms-assets.com/46272/1719377601-play_button_video.png'
                  }
                  alt="play Button"
                  width="full"
                  height="full"
                />
              ) : (
                <TbPlayerPlayFilled />
              )}
            </Flex>
          </Flex>
          <Box
            fontFamily="FedraSansStd-medium"
            color="white"
            fontWeight={450}
            // noOfLines={{ base: '3', sm: '2', lg: '3' }}
            maxW={{ base: checkV5Version ? '100px' : '97px', md: '145px' }}
            {...(checkV5Version
              ? ProgramStepsSt[lang].videoV5
              : ProgramStepsSt[lang].video)}
            dir={lang == 'ar' ? 'rtl' : 'ltr'}
            fontSize={{
              base: checkV5Version || isUsInPerson ? '8.93px' : '10px',
              md: isUsInPerson ? '14.9px' : checkV5Version ? '17.26px' : '1rem',
            }}
            lineHeight={{
              base: checkV5Version ? '16px' : '15px',
              md: checkV5Version ? '21.57px' : '20px',
            }}
          >
            {sectionContent?.title}
          </Box>
        </Flex>
      </Box>
    ) : props?.sectionId === 'surya-shakti-youtube-video-section' ||
      pageName === 'msr-in-person' ? (
      <Box
        display={vidVis ? 'none' : 'block'}
        onClick={e => setVidVis(!vidVis)}
      >
        <svg
          width="78"
          height="54"
          viewBox="0 0 78 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M76.2774 8.4225C75.83 6.79457 74.9572 5.31043 73.7461 4.11788C72.535 2.92534 71.0277 2.06598 69.3744 1.6254C63.3214 0 38.9604 0 38.9604 0C38.9604 0 14.5982 0.0491999 8.54532 1.6746C6.89194 2.11521 5.38463 2.97461 4.1735 4.16721C2.96237 5.35982 2.08967 6.84401 1.64232 8.472C-0.188543 19.0614 -0.89877 35.1972 1.6926 45.363C2.13999 46.9909 3.01271 48.4751 4.22383 49.6676C5.43496 50.8602 6.94225 51.7195 8.5956 52.1601C14.6485 53.7855 39.0101 53.7855 39.0101 53.7855C39.0101 53.7855 63.3714 53.7855 69.424 52.1601C71.0774 51.7196 72.5848 50.8602 73.796 49.6677C75.0071 48.4751 75.8799 46.991 76.3273 45.363C78.2584 34.7586 78.8535 18.6327 76.2774 8.4225Z"
            fill="#FF0000"
          />
          <path
            d="M31.2068 38.4175L51.4162 26.8921L31.2068 15.3667V38.4175Z"
            fill="white"
          />
        </svg>
      </Box>
    ) : useOutlinePlayIcon ? (
      <Flex
        align="center"
        justify="center"
        onClick={() => setVidVis(!vidVis)}
        cursor="pointer"
        display={vidVis ? 'none' : 'flex'}
      >
        <FaRegCirclePlay size="3rem" color="white" />
      </Flex>
    ) : (
      <Flex
        position="relative"
        top={0}
        bottom={0}
        left={0}
        right={0}
        justifyContent="center"
        alignItems="center"
        display={vidVis ? 'none' : 'flex'}
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          w={{ base: '40px', md: '84px' }}
          h={{ base: '40px', md: '84px' }}
          className="play_btn"
          rounded={props.round || 'full'}
          background={props.bgcolor || '#FFCB12'}
          _hover={{
            boxShadow: ' -4px 14px 22px -5px rgba(0,0,0,0.66)',
            background: pageName == 'pbk' ? '#721B0F' : '',
            color: pageName === 'pbk' ? 'white' : '',
          }}
          textAlign="center"
          fontSize={{ base: '15px', md: '30px' }}
          onClick={e => setVidVis(!vidVis)}
          display={vidVis ? 'none' : 'flex'}
          color={props.txtcolor || ''}
        >
          <TbPlayerPlayFilled />
        </Flex>
      </Flex>
    );

  if (pageName === 'MA') {
    return (
      <Box
        mt={
          vidVis ? { base: '2rem', md: '3rem' } : { base: '2rem', md: '3rem' }
        }
        mb={
          vidVis
            ? { base: '0.8rem', md: '2.7rem' }
            : { base: '0.5rem', md: '3rem' }
        }
        w={'100%'}
        onClick={e => setVidVis(!vidVis)}
        cursor={'pointer'}
      >
        {vidVis ? (
          <Flex justifyContent={'center'} maxW="100%" w={screenWidth}>
            <YouTube
              videoId={getEmbedUrl(sectionContent?.video?.url)}
              onReady={onReady}
              opts={opts}
              loading="eager"
              style={{ maxWidth: '1330px', width: screenWidth }}
            />
          </Flex>
        ) : (
          <Image src={imgSrc} width={'100%'} maxW={'1330px'} />
        )}
      </Box>
    );
  } else if (sectionContent?.thumbnailDesktopImage?.url) {
    return (
      <MidContainer
        w={width || { base: '100%', md: '696px' }}
        h={height || '100%'}
        mt={
          props?.sectionId === 'surya-shakti-youtube-video-section'
            ? { base: '0px', md: '3rem', lg: '0px' }
            : undefined
        }
        mb={
          props?.sectionId === 'surya-shakti-youtube-video-section'
            ? { base: '0px', md: vidVis ? '6rem' : '4rem' }
            : undefined
        }
      >
        <Box
          backgroundImage={
            !vidVis ? sectionContent?.thumbnailDesktopImage?.url : 'none'
          }
          bgSize={{ base:'contain', lg: pageName == 'pbk' ? 'inherit' : 'contain' }}
          backgroundSize={{ base: pageName == 'pbk' ? 'cover' : '100%', lg: pageName == 'pbk' ? 'auto' : '100%' }}
          // backgroundColor="#000"
          backgroundRepeat="no-repeat"
          backgroundPosition={
            sectionContent.id === '170001416' ? 'left' : 'center'
          }
          width={pageName === 'msr-in-person' ? width : '100%'}
          position="relative"
          display="flex"
          // boxShadow={{base : pageName == 'pbk' ? 'rgb(38, 57, 77) 0px 13px 19px -10px': '', md:''}}
          justifyContent="center"
          alignItems="center"
          flexDir="column"
          cursor="pointer"
          // onClick={e => setVidVis(!vidVis)}
          top="0px"
          borderRadius={props.round || { base: '6px', md: 'none' }}
          height={
            pageName === 'msr-in-person'
              ? { base: '241px', md: '413px' }
              : {
                  base: pageName == 'pbk' ? '175px' : '280px',
                  md: pageName == 'pbk' ? '413px' : '356px',
                  lg: pageName == 'pbk' ? '413px' : '356px',
                }
          }
          marginTop={
            isUsInPerson
              ? undefined
              : pageName === 'msr-in-person'
              ? { base: '30px', md: '30px' }
              : { lg: '30px', sm: '-30px', base: '-30px' }
          }
          id="embed-vid"
          {...props}
        >
          {playerOverlay}

          {vidVis && (
            <Box maxW="100%" w="full" height={{ base: '200px', md: '390px' }}>
              <YouTube
                videoId={getEmbedUrl(sectionContent?.video?.url)}
                onReady={onReady}
                opts={opts}
                loading="eager"
              />{' '}
            </Box>
          )}
        </Box>
      </MidContainer>
    );
  }

  return (
    <MidContainer w={width || '696px'}>
      <Box
        // backgroundImage={sectionContent?.video?.thumbnailUrl}
        backgroundSize="cover"
        backgroundColor="#000"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        width="100%"
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDir="column"
        cursor="pointer"
        onClick={() => setVidVis(!vidVis)}
        overflow="hidden"
        height={{ base: '300px', md: '430px' }}
        m={margin || '0 auto 30px auto'}
        id="embed-vid"
      >
        {vidVis && (
          <Box maxW="100%" w="full">
            <YouTube
              videoId={getEmbedUrl(sectionContent?.video?.url)}
              onReady={onReady}
              opts={opts}
              loading="lazy"
            />{' '}
          </Box>
        )}
      </Box>
    </MidContainer>
  );
};

export default MediaEmbedV2;
